import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function CfgShiftReduceAxiom() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>Axiom:</div>
        <div className='middle-rule-part'>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[ε, 0]</span>
            </div>
        </div>
    </div>)
}
